const initialState = {
  selectedEmployeeDetails: {},
  planDetails: {},
  isDevAreaspresent: null,
  idpAiEnabled: null,
  currentNovaSuggestions: [],
};

const idp = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SELECTED_EMPLOYEE_DETAILS": {
      return {
        ...state,
        selectedEmployeeDetails: action.payload,
      };
    }
    case "SET_PLAN_DETAILS": {
      return {
        ...state,
        planDetails: action.payload,
      };
    }
    case "IS_DEVELOPMENT_AREAS_PRESENT": {
      return {
        ...state,
        isDevAreaspresent: action.payload,
      };
    }
    case "SET_NOVA_SUGGESTIONS": {
      return {
        ...state,
        currentNovaSuggestions: action.payload,
      };
    }
    case "SET_IDP_AI_ENABLED": {
      return {
        ...state,
        idpAiEnabled: action.payload,
      };
    }
    default:
      return state;
  }
};

export default idp;
